module.exports = __webpack_public_path__ + "img/eadbf99d-16f9-4f89-9ad8-ded13639da40.86f15820.webp";